import templateUrl from 'emun.map/leaflet-view.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

class LeafletViewController  {
    constructor($scope, $geo, $http, leafletData) {
        const $ctrl = this;
		basicController($ctrl);
		$ctrl.token = 'pk.eyJ1IjoiYnJhbmRvbmx1c2siLCJhIjoiY2pmMWk2M2ZtMGUwcjJxbG5udTF1MGlzYyJ9.GFvALV_-d7a6aNuppmAhaw';
		$ctrl.center = {
			lat: 37.0902,
			lng: -95.7129,
			zoom: 4
		}
		$ctrl.tiles = {
			name: 'Mapbox Park',
			url: 'http://api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
			type: 'xyz',
			options: {
				apikey: $ctrl.token,
				mapid: 'mapbox.light'
			}
		}
		$ctrl.fills = {
			'HIGH': '#3182bd',
			'MEDIUM': '#9ecae1',
			'LOW': '#deebf7',
			'defaultFill': '#DDDDDD'
		}
		$ctrl.geojson = {};
		$ctrl.$geo = $geo;
		$ctrl.leafletData = leafletData;
		$ctrl.selectedState = {};

		$ctrl.stateMouseover = function(feature, leafletEvent) {
			var layer = leafletEvent.target;
			layer.setStyle({
				weight: 2,
				color: '#666'
			});
			layer.bringToFront();
			$ctrl.selectedState = feature;
			console.log(feature);
		}

		$ctrl.$on("leafletDirectiveGeoJson.mymap.mouseover", function (ev, leafletPayload) {
			$ctrl.stateMouseover(leafletPayload.leafletObject.feature, leafletPayload.leafletEvent);
		});

		$ctrl.$on("leafletDirectiveGeoJson.mymap.click", function (ev, leafletPayload) {
			$ctrl.leafletData.getMap().then(function (map) {
				map.fitBounds(leafletPayload.leafletObject.getBounds());
			});
		});

		$ctrl.zoomToFeature = function (e) {
			$ctrl.leafletData.getMap().then(function (map) {
				map.fitBounds(e.target.getBounds());
			});
		}

		$http.get("https://s3.amazonaws.com/emuncloud-staticassets/mapfiles/us-states.json").success(function (data, status) {
			data.features.forEach(function (feature) {
				var state = $ctrl.$geo.usaStates.find(function (obj) { return obj.name === feature.properties.name; });
				if (state) {
					feature.properties = angular.extend(feature.properties, {
						"abbr": state.abbreviation
					});
				}
			});
			$ctrl.salesQuery = new AutoQuery({
				url: 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear&GroupBy=SalesRepState',
				autoLoad: true,
				onLoaded: function (args) {
					args.results.forEach(function (res) {
						var feature = data.features.find(function (obj) {
							return obj.properties.abbr === res.salesRepState;
						});
						if (feature) {
							var color = $ctrl.fills.defaultFill;
							if (res.sumTotalSalesYearToDate <= 50000) {
								color = $ctrl.fills.LOW;
							} else if (res.sumTotalSalesYearToDate <= 100000) {
								color = $ctrl.fills.MEDIUM;
							} else {
								color = $ctrl.fills.HIGH;
							}
							feature.properties = angular.extend(feature.properties, {
								"fillColor": color,
								"sales": res.sumTotalSalesYearToDate
							});
						}
					});
					$ctrl.style = function (feature) {
						return {
							fillColor: feature.properties.fillColor,
							weight: 2,
							opacity: 1,
							color: 'white',
							dashArray: '3',
							fillOpacity: 0.7
						};
					}
					$ctrl.geojson = {
						data: data,
						style: $ctrl.style,
						resetStyleOnMouseout: true
					}
					$ctrl.legend = {
						colors: [$ctrl.fills.defaultFill, $ctrl.fills.LOW, $ctrl.fills.MEDIUM, $ctrl.fills.HIGH],
							labels: ['No Sales', '$1 - $50,000', '$50,001 - $100,000', '> $100,000']
					}
				}
			});
		});

	}
}

let LeafletView = {
    controller: LeafletViewController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default LeafletView;